import React, { Component } from 'react';
import config from '../../../config';

export const WithMethods = (WrappedComponent) => {
  return class CustomerVoucherApi extends Component {
    index(options = {}) {
      const params =
        Object.entries(options).map(([key, val]) => `${key}=${val}`).join('&');

      return $.get(`${config.localeApi}/voucher?${params}`);
    }

    update(code, data) {
      return $.ajax({
        url: `${config.localeApi}/voucher/${code}/extend`,
        type: 'PUT',
        dataType: 'json',
        data: data,
      });
    }

    getVoucherProducts(voucherCode) {
      return $.ajax({
        url: `${config.localeApi}/voucher/${voucherCode}/products`,
        method: 'GET',
        dataType: 'json',
      });
    }

    activateVoucher(voucherCode) {
      return $.ajax({
        url: `${config.localeApi}/voucher/claim`,
        method: 'POST',
        dataType: 'json',
        data: {
          voucher_code: voucherCode
        }
      });
    }

    render() {
      return (
        <WrappedComponent
          {...this.props}
          index={this.index}
          update={this.update}
          getVoucherProducts={this.getVoucherProducts}
          activateVoucher={this.activateVoucher}
        />
      )
    }
  }
};




// WEBPACK FOOTER //
// ./src/Common/Providers/CustomerVoucherApi.js